import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const Container = styled.label(
    ({ theme }) => css`
        display: flex;
        padding: ${theme.spacing.medium};
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0;
            margin-bottom: ${theme.spacing.medium};
        }
    `,
)

export const InputContainer = styled.input(
    ({ theme }) => css`
        appearance: none;
        position: relative;
        display: inline-block;
        height: 1.25rem;
        width: 1.25rem;
        color: ${theme.colors.white};
        border: ${theme.typography.border.radius.xxxSmall} ${theme.typography.border.style.solid} #0000004d;
        cursor: pointer;
        border-radius: 100%;
        background-color: ${theme.colors.white};
        padding: 0.5625rem;

        &:checked {
            background-color: ${theme.colors.black};
            border: 0 !important;

            &::after {
                position: absolute;
                top: 0.3125rem;
                left: 0.3125rem;
                width: 0.625rem;
                height: 0.625rem;
                border: 0;
                border-radius: 100%;
                content: '';
                background-color: ${theme.colors.white};
                padding: 0;
            }
        }
    `,
)

export const TextContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        padding-left: 0.625rem;
        font: ${theme.typography.font.lato.weight.bold} ${theme.typography.font.size.medium} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            width: ${theme.layout.fill};
            justify-content: space-between;
            font-weight: ${theme.typography.font.lato.weight.regular};
            font-size: ${theme.typography.font.size.small};
        }
    `,
)

export const Order = styled.span(
    ({ theme }) => css`
        font-weight: ${theme.typography.font.lato.weight.regular};
        margin-left: ${theme.spacing.xxSmall};
    `,
)
